import { render, staticRenderFns } from "./PeriodCalendar.vue?vue&type=template&id=6610234c&scoped=true"
import script from "./PeriodCalendar.vue?vue&type=script&lang=js"
export * from "./PeriodCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6610234c",
  null
  
)

export default component.exports